'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _sortBy = require('lodash/sortBy');

var _sortBy2 = _interopRequireDefault(_sortBy);

var _filter = require('lodash/filter');

var _filter2 = _interopRequireDefault(_filter);

var _fabfitfunSharedGlobal = require('@bit/fabfitfun.shared.global.button');

var _fabfitfunSharedGlobal2 = _interopRequireDefault(_fabfitfunSharedGlobal);

var _imgMysteryBox = require('./img-mystery-box.svg');

var _imgMysteryBox2 = _interopRequireDefault(_imgMysteryBox);

require('./Box.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Box = function Box(props) {
  var getLatestBox = function getLatestBox(boxes) {
    var shipped = (0, _filter2.default)(boxes, function (box) {
      return box.shipDate;
    });

    var ordered = (0, _sortBy2.default)(shipped, function (box) {
      var unixShipTime = new Date(box.shipDate).getTime() / 1000;
      return unixShipTime;
    }).reverse();

    return ordered[0];
  };

  var data = props.data;
  var currentBox = data.currentBox,
      shiplist = data.shiplist;

  var _ref = currentBox || getLatestBox(shiplist),
      name = _ref.name,
      imageUrl = _ref.imageUrl,
      boxRevealed = _ref.boxRevealed;

  var showPastBox = currentBox ? false : true;
  var img = imageUrl && (showPastBox || boxRevealed) ? imageUrl : _imgMysteryBox2.default;

  return _react2.default.createElement(
    'div',
    { className: 'box ta-center' },
    _react2.default.createElement('img', { className: 'my-box-image', src: img, alt: name }),
    _react2.default.createElement(
      'p',
      { className: 'mar-0' },
      name
    )
  );
};

exports.default = Box;


Box.defaultProps = {
  name: ''
};

Box.propTypes = {
  name: _propTypes2.default.string,
  img: _propTypes2.default.string
};

//# sourceMappingURL=Box.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@bit/fabfitfun.shared.global.layout-reader/node_modules/@bit/fabfitfun.my-box.global.my-box-header/dist/Box/Box.js
// module id = 626
// module chunks = 0